import { useNavigate } from "react-router";
import { useDependencyInjection } from "../../../../config/di/dependency_injection_context";
import { usePageLoader } from "../../../../common/contexts/page_content_context";
import { useCallback, useState } from "react";
import { usePageStartBootstrap } from "../../../../common/hooks/use_page_start_bootstrap";
import { processError } from "../../../../common/utils/base_error";
import { useObrasTopHeaderState } from "../../../obras/presentation/components/hooks/obras_top_header_state";
import CommonConstants from "../../../../common/constants";
import { PrincipalDocumentosLista } from "../../../auditoria/domain/models/documentos_lista";
import { useMaquinasEquipControlePagination } from "../hooks/MaquinasEquip_controle/pagination";


type LoadPrincipalListaFuncState = {
  IdArquivoModulo?: number;
  page?: number;
  rowsPerPage?: number;
  tipoPesquisa?: number,
  pesquisa?: string,
};

export const useControlePatriPrincipalViewModel = () => {
  const {
    commons: { getAllListagemDocUseCase, getGedArquivoDataUseCase},
    reports: {},
  } = useDependencyInjection();


  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [docLista, setDocLista] = useState<PrincipalDocumentosLista[]>([]);
  const navigate = useNavigate();



  const {pushErrorNotification } = usePageLoader();

  const obrasTopHeaderState = useObrasTopHeaderState();
   const pagination = useMaquinasEquipControlePagination();

  // #region Funções de carregamento

  const loadDocListaState = useCallback(async (funcState?: LoadPrincipalListaFuncState) => {
    try {
        const filteredPage = funcState?.page ?? pagination.page;
        const filteredRowsPerPage = funcState?.rowsPerPage ?? pagination.rowsPerPage;
        await getAllListagemDocUseCase.getAllListagemDoc(
          String(CommonConstants.moduloDocumentos.MaquinaEquip),
            filteredPage,
            filteredRowsPerPage
        );
        setDocLista(getAllListagemDocUseCase.items);
        pagination.setRowsPerPage(getAllListagemDocUseCase.pageSize);
        pagination.setTotalItems(getAllListagemDocUseCase.totalItems);
    } catch (e: unknown) {
        throw new Error("Falha ao buscar documentos!");
    }
  }, [getAllListagemDocUseCase, pagination]);


  //#endregion
  // #region useEffect
  usePageStartBootstrap(async () => {
    try {
      const jobs = [];

      jobs.push(loadDocListaState());
      await Promise.all(jobs);
    } catch (e: unknown) {
      setErrorMessage(processError(e, 'Falha ao buscar dados da pagina!')[0]);
    }
  });

  const handleReload = useCallback(async () => {
    try {
      const jobs = [];
      setLoading(true);
      jobs.push(loadDocListaState());
      await Promise.all(jobs);
    } catch (e: unknown) {
      pushErrorNotification('Erro', processError(e, 'Falha ao buscar dados da pagina!'));
    } finally {
      setLoading(false);
    }
  }, [loadDocListaState, pushErrorNotification]);
  //#endregion

  // #region Eventos
  const handleDownloadFile = useCallback(async (IdArquivoModulo: number, NomeArquivo: string) => {
    if (IdArquivoModulo > 0) {
      try {
        setLoading(true);
        await getGedArquivoDataUseCase
          .getGedArquivoData(IdArquivoModulo, NomeArquivo);
      } catch (e: unknown) {
        pushErrorNotification("Erro", processError(e, 'Falha ao buscar documentos!'));
      } finally {
        setLoading(false);
      }
    }
  }, [getGedArquivoDataUseCase, pushErrorNotification]);
  

  const handlePageChange = useCallback(async (page: number) => {
    try {
      setLoading(true);
      pagination.setPage(page + 1);;
      await loadDocListaState({page: page + 1,});
    } catch (e: unknown) {
      pushErrorNotification('Erro', processError(e, 'Falha ao buscar dados da pagina!'));
    } finally {
      setLoading(false);
    }
  }, [loadDocListaState, pagination, pushErrorNotification]);


  const handleRowsPerPageChange = useCallback(async (rowsPerPage: number) => {
  try {
      setLoading(true);
      pagination.setPage(1);
      pagination.setRowsPerPage(rowsPerPage);

      await loadDocListaState({ page: 1, rowsPerPage });
  } catch (e: unknown) {
    pushErrorNotification('Erro', processError(e, 'Falha ao buscar dados da pagina!'));
  } finally {
    setLoading(false);
  }
  }, [loadDocListaState, pagination, pushErrorNotification]);


  //#endregion
  
  return {
      loading,
      errorMessage,
      obrasTopHeaderState,
      docLista,
      pagination,
      handleReload,
      handlePageChange,
      handleRowsPerPageChange,
      handleDownloadFile,
  }
}